<template>
    <v-row class="mx-1 my-7">
        <slot name="meta" />

		<v-col v-if="contentData.GroupTitle" cols="12">
			<h3 class="q-title">{{ contentData.GroupTitle }}</h3>
		</v-col>

		<slot name="Buttons">
        	<div class="columns-wrapper align-stretch" :style="itemsStyle">
                <div v-for="(button, key) in contentData.Buttons" :key="key" class="column-item pa-2">
                    <v-btn class="q-multi-line-btn" dark :color="button.color" block x-large @click="clicked(button.href, button.newWindow)">
                        <strong>{{ button.text }}</strong>
                    </v-btn>
                </div>
			</div>
		</slot>
    </v-row>
</template>

<script>
import { CmsGroupViewMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    name: "ButtonGroup",
    mixins: [CmsGroupViewMixin],
    props: {
        contentData: {
            type: Object,
            default: function() {
                return {
                    Buttons: [{}],
                    GroupTitle: '',
                    NumColumns: 4,
                }
            }
        }
    },
    methods: {
        clicked (href, newWindow) {
            if (href.indexOf('http') > -1) {
                if (href.indexOf('quility.com') > -1 && newWindow != "_blank") {
                    document.location = href
                } else {
                    window.open(href, newWindow);
                }
            } else {
                this.$router.push(href)
            }
        }
    },
}
</script>

<style lang="scss">
.q-multi-line-btn {
    // Multi line buttons are bad, but we use it here for mobile.

    .v-btn__content {
        flex-shrink: 1;
        white-space: normal
    }
}
</style>